import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';

export default function CameraInfoDialog(props) {

    const { onClose, camera_info = {}, profile_list = [] } = props;

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <Tx>camera.infoDialog.title</Tx> [{props.name}]
            </DialogTitle>
            <DialogContent style={{ paddingTop: 5 }}>

                {
                    Object.keys(camera_info).length && <div style={{marginBottom: 10}}>

                        <div>
                            <b><Tx>camera.infoDialog.cameraInfo</Tx></b>
                        </div>

                        <div style={{ fontSize: 12 }}>
                            {
                                Object.keys(camera_info).map(key => <div key={key}>{key}: {camera_info[key]}</div>)
                            }
                        </div>
                    </div>
                }

                {
                    profile_list.length && <div>

                        <div>
                            <b><Tx>camera.infoDialog.cameraProfiles</Tx></b>
                        </div>

                        <div style={{fontSize: 12}}>
                            {
                                profile_list.map((profile, idx) => <div key={idx}>

                                    <div style={{marginTop: 5}}>
                                        <b>{profile.name}</b>
                                    </div>
                                    <div>
                                        <Tx>camera.infoDialog.resolution</Tx>: {`${profile.video.encoder.resolution.width} x ${profile.video.encoder.resolution.height}`}
                                    </div>
                                    <div>
                                        <Tx>camera.infoDialog.encoding</Tx>: {profile.video.encoder.encoding}
                                    </div>
                                    <div>
                                        <Tx>camera.infoDialog.bitrate</Tx>: {profile.video.encoder.bitrate}
                                    </div>
                                    <div>
                                        <Tx>camera.infoDialog.framerate</Tx>: {profile.video.encoder.framerate}
                                    </div>

                                </div>)
                            }
                        </div>

                    </div>
                }
                
                {
                    profile_list?.length && profile_list[0].snapshot && <img src={profile_list?.length && profile_list[0].snapshot} style={{width: '100%', marginTop: 5}} />
                }

            </DialogContent>

            <DialogActions>

                <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                <Button autoFocus type='submit'>
                    <Tx>g.save</Tx>
                </Button>

            </DialogActions>
        </Dialog>)
}